import en from './en';
import pl from './pl';
import lt from './lt';

export default { en, pl, lt };
